import React from 'react';
import { useSelector } from 'react-redux';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Typography } from '@mui/material';

import * as ShopSelectors from 'selectors/ShopSelectors';
import * as ViewSelectors from 'selectors/ViewSelectors';

import { getTranslation } from 'common/modules/translations';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	carrierId: string;
}

const RentalCardCarrierInfo = (props: Props) => {
	const { carrierId } = props;
	const classes = useStyles();
	const { t } = useTranslation();
	const shopCarriers = useSelector(ShopSelectors.activeShopCarriers);
	const carrierInfo = shopCarriers.find((carrier) => carrier.id === carrierId);
	const language = useSelector(ViewSelectors.lang);

	return (
		<div className={classes.root}>
			<Typography variant="body2" color="textSecondary" align="right">
				{t('delivery.carrier')}
			</Typography>
			<Typography variant="body1" align="right">
				{carrierInfo
					? getTranslation(carrierInfo.name, language)
					: t('delivery.noCarrier', 'No carrier')}
			</Typography>
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
	}),
);

export default RentalCardCarrierInfo;
